import styled from 'styled-components';
import { colors } from '@alixpartners/ui-components';
import { Link } from 'react-router-dom';

export const Wrapper = styled.div`
  padding: 0px 30px;
  display: flex;
  min-height: 48px;
  align-items: center;
  border-bottom: 1px solid ${colors.amber};
`;

export const RightSection = styled.div`
  margin-left: auto;
  display: flex;
`;

export const ActionItem = styled.div`
  padding: 0 11px;
`;

export const Divider = styled.div`
  border-left: 1px solid ${colors.grey2};
  height: 24px;
  margin: 0 5px 0 16px;
  align-self: center;
`;

export const Title = styled.div`
  font-weight: normal;
  font-size: 19px;
  line-height: 27px;
  color: ${colors.black};
  margin-left: 24px;
  white-space: nowrap;
`;

export const StyledLink = styled(Link)`
  text-decoration: none;
`;
